/** Premium positioning shared across every section (edition, access, support, contrast). */

export const PREMIUM = {
  edition: 'Craft Fair & Christmas Edition',
  editionShort: '2026 Edition',
  access: 'Free updates · Lifetime access',
  support: 'Personal email support',
  pages: '240 pages',
} as const

export const BONUS_LINE_SHORT = 'Plus 5 premium bonuses, included free.'

export const PREMIUM_SEALS: string[] = ['7-day guarantee', '2026 Edition', 'Lifetime access', 'Email support']

export interface ContrastRow {
  ours: string
  theirs: string
}

export const CONTRAST: ContrastRow[] = [
  { ours: '30 complete projects for a one-time US$27', theirs: 'A monthly membership that keeps charging you' },
  { ours: 'Small builds you can batch from standard lumber', theirs: 'Big projects that tie up your shop for weeks' },
  { ours: 'Exact cut lists in inches & mm, 3-view plans', theirs: 'A pretty photo that skips the step that matters' },
  { ours: 'A build & sell card and pricing worksheet for every project', theirs: 'Guessing what to charge at the booth' },
  { ours: 'Christmas decor, gifts, toys, kitchen and pet pieces', theirs: 'Random ideas with no plan behind them' },
]
